import React, { useState, useEffect } from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';

interface CustomDatePickerProps {
  value: Date | null;
  onChange: (date: Date) => void;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({ value, onChange }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (value) {
      const day = value.getDate().toString().padStart(2, '0');
      const month = (value.getMonth() + 1).toString().padStart(2, '0');
      const year = value.getFullYear().toString();
      setInputValue(`${day}/${month}/${year}`);
    } else {
        if (inputValue === '') setInputValue('');
    }
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value;

    // Filter invalid chars (only numbers and slashes allowed)
    val = val.replace(/[^0-9/]/g, '');

    // Auto-add slash if typing forward (not deleting)
    if (val.length > inputValue.length) {
        if (val.length === 2) {
            val += '/';
        } else if (val.length === 5) {
            val += '/';
        }
    }
    
    // Limit length to 10 chars (DD/MM/YYYY)
    if (val.length > 10) val = val.slice(0, 10);

    setInputValue(val);

    const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const match = val.match(regex);

    if (match) {
      const day = parseInt(match[1], 10);
      const month = parseInt(match[2], 10) - 1;
      const year = parseInt(match[3], 10);

      const date = new Date(year, month, day);
      
      if (
        date.getFullYear() === year &&
        date.getMonth() === month &&
        date.getDate() === day &&
        year > 1800 && year < 2100
      ) {
        onChange(date);
      }
    }
  };

  return (
    <div className="relative w-full">
      <CalendarIcon className="absolute left-3 top-3.5 text-gray-400" size={18} />
      <input
        type="text"
        autoComplete="off"
        placeholder="DD/MM/YYYY"
        value={inputValue}
        onChange={handleInputChange}
        className="w-full bg-input border border-gray-700 rounded-lg p-3 pl-10 text-white placeholder-gray-500 focus:border-[var(--season-primary)] focus:ring-1 focus:ring-[var(--season-primary)] outline-none transition-all h-[50px]"
      />
    </div>
  );
};

export default CustomDatePicker;